import { WordPress } from "../../../../wordpress/wordpress_api";
import { CMSState, Link } from "../../../../cms/blocks/types.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { IOWidget, Action, mk_widget } from "widgets-for-react";
import { PublicSiteState } from "../../../../public_site.main.mod";
import React from "react";
import { link, linkWrapper } from "../../../../cms/blocks/utils.gen";
import { ButtonData } from "../../../../wordpress/types_and_parser/extra_types.mod";
import { getImageAttribute } from "../../../utils/extra_images.mod";

export type GridBlockItem = {
    title: string
    intro: string
    image?: WordPress.MediaResponse
    icon?: WordPress.MediaResponse
    link?: Link
}

export type GridAttributes = {
    blockName: 'vidda/grid'
    title: string
    intro: string
    primary_button?: ButtonData
    secondary_button?: ButtonData
    blocks: Array<GridBlockItem>
}

export interface GridInterface {
    blockName: 'vidda/grid'
    attrs: GridAttributes
}

export type GridBlockProps<extra_images> = GridAttributes

export type GridBlockStyle = Partial<{
    block_classname: string
    inner_classname: string
    header_classname: string
    title_classname: string
    content_classname: string
    intro_classname: string
    visual_classname: string
}>


export function GridBlock<customBlockData, extra_images>(
    props: GridBlockProps<extra_images>,
    options?: { style: GridBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
    return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
        return mk_widget({
          run: (_) => (
            <section className="block block--grid block--light">
              <div className="block__inner grid--spacing">
                <header className="block__header container--s grid--gutter">
                  {props.title && <h2 className="block__title typo--xl">{props.title}</h2>}
                  {props.intro && (
                    <div className="block__intro text--styled" dangerouslySetInnerHTML={{__html: props.intro}}></div>
                  )}
                </header>

                <div className="block__content">
                  <ul className="block__grid grid">
                    {props.blocks.map((grid) => (
                      <li className="grid__item">
                        {grid.link ? (
                          link(grid.link, { classname: "grid__link" }, <>
                            <div className={`grid__content${grid.icon ? ' grid__content--icon' : ''}`}>
                              {grid.title && <h3 className="grid__title typo--m">{grid.title}</h3>}
                              {grid.intro && <p className="grid__intro typo--xs">{grid.intro}</p>}
                              {grid.link && <span className="grid__fauxlink">{grid.link.title}</span>}
                              {grid.icon && (
                                <div className="grid__icon">
                                  <img
                                    src={getImageAttribute(grid.icon, 'thumbnail', 'source_url')}
                                    width={getImageAttribute(grid.icon, 'thumbnail', 'width')}
                                    height={getImageAttribute(grid.icon, 'thumbnail', 'height')}
                                    alt={grid.icon.alt_text ? grid.icon.alt_text : ''}
                                  />
                                </div>
                              )}
                            </div>

                            {grid.image ? (
                              <div
                                className="grid__visual grid-has-image"
                                style={{ backgroundImage: `url('${getImageAttribute(grid.image, 'grid', 'source_url')}')` }}
                              ></div>
                            ) : (
                              <div className="grid__visual"></div>
                            )}
                          </>)
                        ) : (
                          <div className="grid__inner">
                            <div className={`grid__content${grid.icon ? ' grid__content--icon' : ''}`}>
                              {grid.title && <h3 className="grid__title typo--m">{grid.title}</h3>}
                              {grid.intro && <p className="grid__intro typo--xs">{grid.intro}</p>}
                              {grid.icon && (
                                <div className="grid__icon">
                                  <img
                                    src={getImageAttribute(grid.icon, 'thumbnail', 'source_url')}
                                    width={getImageAttribute(grid.icon, 'thumbnail', 'width')}
                                    height={getImageAttribute(grid.icon, 'thumbnail', 'height')}
                                    alt={grid.icon.alt_text ? grid.icon.alt_text : ''}
                                  />
                                </div>
                              )}
                            </div>

                            {grid.image ? (
                              <div
                                className="grid__visual grid-has-image"
                                style={{ backgroundImage: `url('${getImageAttribute(grid.image, 'grid', 'source_url')}')` }}
                              ></div>
                            ) : (
                              <div className="grid__visual"></div>
                            )}
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
                {(props.primary_button || props.secondary_button) && (
                  <footer className="block__footer container--s grid--gutter">
                    {props.primary_button &&
                      link(
                        linkWrapper({title: props.primary_button.text, url: props.primary_button.url}),
                        {classname: "button button--primary"},
                        props.primary_button.text
                      )}
                    {props.secondary_button &&
                      link(
                        linkWrapper({title: props.secondary_button.text, url: props.secondary_button.url}),
                        {classname: "link link--primary"},
                        props.secondary_button.text
                      )}
                  </footer>
                )}
              </div>
            </section>
          ),
        });
    }
}